<template>
  <mock-up-main>
    <div
      v-if="loading"
      class="fill-height d-flex align-center justify-center white"
      style="position: absolute; inset: 0; z-index: 10"
    >
      <v-progress-circular color="primary" height="5" indeterminate />
    </div>
        <universal-qr-modal
          v-model="showQrDialog"
          :title="value?.visitName || 'صفخه کاری'"
          :subtitle="'برای دریافت اطلاعات، کیوآر زیر را اسکن کنید.'"
          :identifier="value?.identifier || ''"
          :profile-avatar="value?.photo?.profile || ''"
          :primary-color="primaryActionColor"
          :svg-data="qrSvgDataUrl"
        />
        <!-- دکمه شناور اسکن QR -->
        <v-btn
          fab
          x-small
          elevation="4"
          class="qr-floating-btn"
          title="مشاهده و اسکن کیوآر کد"
          @click="showQrDialog = true"
        >
          <v-icon size="18">mdi-qrcode-scan</v-icon>
        </v-btn>

    <slot v-if="!!value" name="default">
      <!-- bannerSection -->
      <b-intro-slider-view
        v-if="value.banner?.gallery?.length > 0"
        v-model="computedBanner"
        :is-slider="false"
        type="banner"
      />
      <!-- bannerSection -->

      <b-special-category-view
        v-if="
          !!value &&
          !!value.specialCategories &&
          value.specialCategories?.items?.length > 0
        "
        v-model="value.specialCategories"
      />

      <!--      <template v-if="true">-->
      <div
        v-if="
          !!value &&
          !!value.product &&
          !!value.product.items &&
          !!value.product.items.length > 0
        "
        :style="{
          background: value.product.sectionColor.backGround,
          color: value.product.sectionColor.text,
        }"
      >
        <v-card-title class="text-center justify-center pa-2">
          {{ value.product.title }}
        </v-card-title>
        <v-card-subtitle class="ma-0 pa-2 text-center">
          {{ value.product.description }}
        </v-card-subtitle>

        <m-category-view
          v-model="selectedCategory"
          :filters.sync="categoryFilter"
          :items="value.product.items"
        />

        <div
          v-if="!!value.product && !!value.product.items[selectedCategory]"
          class="pa-2"
        >
          <div
            v-for="(product, i) in getProductList"
            :key="i"
            class="rounded-lg mb-3"
          >
            <m-product-card :value="product" :key="$i18n.locale + '-' + i" />
          </div>
        </div>
      </div>
      <!--      </template>-->

      <!--      <products-list-->
      <!--        v-else-if="value.product && value.product.items && value.product.items.length > 0" v-model="value.product"/>-->

      <!-- servicesSection -->
      <b-service-view
        v-if="value.service"
        v-model="value.service"
        :description="value.Service.description"
        :style="{
          background: value.Service.sectionColor.backGround,
          color: value.Service.sectionColor.text,
        }"
        :color="value.Service.sectionColor.text"
        :title="value.Service.title"
        type="icon"
      />
      <!-- servicesSection -->

      <!-- faqSection -->
      <b-faq-view
        v-if="!!value.faq && !!value.faq.items.length"
        v-model="value.faq"
        :style="{
          background: value.faq.sectionColor.backGround,
          color: value.faq.sectionColor.text,
        }"
        :color="value.faq.sectionColor.text"
      />
      <!-- faqSection -->

      <!-- gallerySection -->
      <gallery-slider
        v-if="value && value.PicSelector && value.PicSelector.slider"
        v-model="value.gallery"
        :description="value.PicSelector.description"
        :style="{
          background: value.PicSelector.sectionColor.backGround,
          color: value.PicSelector.sectionColor.text,
        }"
        :title="value.PicSelector.title"
      />

      <b-gallery-view
        v-else-if="value && value.PicSelector"
        v-model="value.gallery"
        :description="value.PicSelector.description"
        :is-img="true"
        :style="{
          background: value.PicSelector.sectionColor.backGround,
          color: value.PicSelector.sectionColor.text,
        }"
        :title="value.PicSelector.title"
      />
      <!-- gallerySection -->

      <!-- VideogallerySection -->
      <b-gallery-view
        v-if="
          value.video_gallery?.length > 0 &&
          value.video_gallery?.filter((item) => item.images?.length > 0)
            ?.length > 0 &&
          value &&
          value.VideoGallery &&
          !value.VideoGallery.slider &&
          value.VideoGallery.sectionColor
        "
        v-model="value.video_gallery"
        :description="value.VideoGallery.description"
        :is-img="false"
        :style="{
          background: value.VideoGallery.sectionColor.backGround,
          color: value.VideoGallery.sectionColor.text,
        }"
        :title="value.VideoGallery.title"
        type="video_gallery"
      />
      <!-- VideogallerySection -->

      <!-- pdfSection -->
      <div v-if="value.pdf && value.pdf.length > 0">
        <pdf-preview-display
          :pdf-data="value.pdf"
          :layout-mode="layoutPreference"
          :pdf-selector="value.pdfSelector"
          :style="{
            background: value.pdfSelector.sectionColor.backGround,
            color: value.pdfSelector.sectionColor.text,
          }"
        />
      </div>
      <!-- <b-gallery-view
        v-if="value && value.pdfSelector && !value.pdfSelector.slider"
        v-model="value.pdf"
        :description="value.pdfSelector.description"
        :is-img="true"
        :style="{
          background: value.pdfSelector.sectionColor.backGround,
          color: value.pdfSelector.sectionColor.text,
        }"
        :title="value.pdfSelector.title"
        type="pdf"
      /> -->
      <!-- gallerySection -->

      <!-- <gallery-slider
        v-else-if="value && value.pdfSelector"
        v-model="value.pdf"
        :description="value.pdfSelector.description"
        :title="value.pdfSelector.title"
        type="pdf"
      /> -->
      <!-- pdfSection -->

      <b-blog-view
        v-if="value.blog"
        v-model="value.blog"
        :description="value.Blog.description"
        :style="{
          background: value.Blog.sectionColor.backGround,
          color: value.Blog.sectionColor.text,
        }"
        :bstyle="value.Blog.sectionColor"
        :title="value.Blog.title"
        :type="value.Blog.slider ? 'slider' : 'default'"
      />

      <b-feedback-view
        v-if="value.FeedBack && value.FeedBack.items.length > 0"
        v-model="value.FeedBack"
        :style="{
          background: value.FeedBack.sectionColor.backGround,
          color: value.FeedBack.sectionColor.text,
        }"
      />

      <b-section-view
        v-if="value.ServiceSection && value.ServiceSection.items.length > 0"
        v-model="value.ServiceSection"
        :style="{
          background: value.ServiceSection.sectionColor.backGround,
          color: value.ServiceSection.sectionColor.text,
        }"
      />

      <b-testimonials-view
        v-if="value.CounterService && value.CounterService.items.length > 0"
        v-model="value.CounterService"
      />

      <!-- <forms-ui
        v-if="
          value.consultation &&
          value.consultation.items &&
          Object.values(value.consultation.items).filter(
            (item) => item.is_active
          ).length > 0
        "
        v-model="value.consultation.items"
        :description="value.consultation.description"
        :style="{
          background: value.consultation.sectionColor.backGround,
          color: value.consultation.sectionColor.text,
        }"
        :title="value.consultation.title"
      /> -->
      <consultation-new-show
        :style="{
          background: value.consultation.sectionColor.backGround,
          color: value.consultation.sectionColor.text,
        }"
        :color="value.consultation?.sectionColor?.text"
        v-model="value.consultation"
      />

      <team-ui v-model="value.personnel" />
      <count-down
        v-if="
          value &&
          value.Counter &&
          value.Counter.until !== '' &&
          isFutureDate(value.Counter.until)
        "
        v-model="value.Counter.until"
        :description="value.Counter.description"
        :title="value.Counter.title"
      />

      <b-footer-view
        v-if="value && value.textCards && !isCleared"
        v-model="value"
        :style="{
          background: value.textCards.sectionColor.backGround,
          color: value.textCards.sectionColor.text,
        }"
        class="mt-10"
      />
    </slot>
  </mock-up-main>
</template>

<script>
import BIntroSliderView from "../../components/view/bIntroSliderView";
import BFooterView from "../../components/view/bFooterView";
import GallerySlider from "../../components/view/gallerySlider";
import BFeedbackView from "../../components/view/bFeedbackView";
import FormsUi from "../../../../components/formsUi";
import BTestimonialsView from "../../components/view/bTestimonialsView";
import MockUpMain from "../../components/mockUp";
import CountDown from "./components/countDown";
import TeamUi from "@/view/components/Personnel/teamUi";
import ProductUi from "@/view/components/Product/productUi";
import ProductsList from "@/view/components/Product/products";
import BSectionView from "@/view/pages/businessPage/components/view/bSectionView";
import AdsComponents from "@/view/components/Product/AdsComponents";
import MCategoryView from "@/view/pages/otherQrTypes/menu/cm/mCategoryView";
import MProductCard from "@/view/components/Product/mProductCard";
import BSpecialCategoryView from "@/view/pages/businessPage/components/view/bSpecialCategoryView.vue";
import BGalleryView from "../../components/view/bGalleryView.vue";
import BBlogView from "../../../commercial/components/view/bBlogView.vue";
import BFaqView from "../../../commercial/components/view/bFaqView.vue";
import BServiceView from "../../components/view/bServiceView.vue";
import ConsultationNewShow from "../../../../components/consultationNew/consultationNewShow.vue";
import PdfPreviewDisplay from "@/view/components/Gallery/PdfPreviewDisplay";
import UniversalQrModal from "../../../../components/UniversalQrModal.vue";

export default {
  name: "viewShop",

  components: {
    BSpecialCategoryView,
    PdfPreviewDisplay,
    MProductCard,
    MCategoryView,
    AdsComponents,
    BSectionView,
    ProductsList,
    ProductUi,
    TeamUi,
    CountDown,
    MockUpMain,
    FormsUi,
    BTestimonialsView,
    BFeedbackView,
    BServiceView,
    BGalleryView,
    BFaqView,
    BFooterView,
    BIntroSliderView,
    GallerySlider,
    BBlogView,
    ConsultationNewShow,
    UniversalQrModal
  },

  props: {
    value: Object,
    loading: Boolean,
    isCleared: Boolean,
    qrSvgDataUrl: {
      type: String,
      default: "",
    },
  },

  data: () => ({
    showQrDialog: false,
    selectedCategory: 0,
    categoryFilter: {
      sub: null,
    },
  }),
  watch: {
    value: {
      handler(newValue) {
        this.$forceUpdate();
      },
      deep: true,
    },
    "$i18n.locale": {
      handler(newLocale) {
        this.$forceUpdate();
      },
      immediate: true,
    },
  },
  methods: {
    isFutureDate(value) {
      const now = new Date();
      const untilDate = new Date(value);
      if (isNaN(untilDate.getTime())) return false;
      return untilDate > now;
    },
  },
  computed: {
    primaryActionColor() {
      return this.value?.pallete?.bodyColor || "#1976D2";
    },
    layoutPreference() {
      if (this.value.pdfSelector && this.value.pdfSelector.slider) {
        return "slider";
      }
      if (this.value.pdfSelector && this.value.pdfSelector.layout) {
        return this.value.pdfSelector.layout;
      }

      return "list";
    },

    computedBanner: {
      get() {
        if (this.value?.banner?.gallery && this.value.banner.gallery[0])
          return {
            banner: this.value.banner.gallery[0],
          };
        else {
          return null;
        }
      },
    },
    getProductList() {
      // Helper function to get products recursively
      const getProductsRecursive = (item) => {
        let productsList = [];

        if (item?.children?.length) {
          // If the item has children, recursively fetch products from each child
          item.children.forEach((child) => {
            if (
              this.categoryFilter.sub == null ||
              (child.id || child.slug) === this.categoryFilter.sub
            ) {
              productsList = productsList.concat(getProductsRecursive(child)); // Recursive call for each child
            }
          });
        } else {
          // If no children, just collect the products from this item
          productsList = item?.products || [];
        }

        return productsList;
      };

      // Now, map through the selected category and apply the recursive function
      return this.value.product.items
        .filter((item, index) => index === this.selectedCategory)
        .map((item) => getProductsRecursive(item)) // Apply the recursive function
        .filter((list) => list.length > 0) // Filter out empty lists
        .flat(); // Flatten the resulting arrays
    },
  },
};
</script>

<style scoped>
.qr-floating-btn {
  position: absolute;
  top: 44px;
  left: 14px;
  z-index: 20;
  background-color: rgba(255, 255, 255, 0.9) !important;
}
</style>
